/* eslint-disable */
/* prettier-ignore-file */
// @ts-nocheck
// Ce fichier est généré automatiquement par GraphQL Codegen
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { graphqlClient } from '@/shared/lib/graphql-client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
};

export type Analysis = {
  __typename?: 'Analysis';
  analysedProductCount: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  inactivatedAt: Maybe<Scalars['DateTime']['output']>;
  isPublic: Scalars['Boolean']['output'];
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  newSells: Maybe<Scalars['Float']['output']>;
  pageUrl: Scalars['String']['output'];
  publicCategoryId: Maybe<Scalars['ID']['output']>;
  status: AnalysisStatus;
  type: AnalysisType;
  userId: Maybe<Scalars['ID']['output']>;
};

export type AnalysisBrandDistribution = {
  __typename?: 'AnalysisBrandDistribution';
  avgSellsPrice: Scalars['Float']['output'];
  brand: Scalars['String']['output'];
  sellsCount: Scalars['Int']['output'];
  totalSellsPrice: Scalars['Float']['output'];
};

export type AnalysisCategoryDistribution = {
  __typename?: 'AnalysisCategoryDistribution';
  avgSellsPrice: Scalars['Float']['output'];
  categoryName: Scalars['String']['output'];
  fullPath: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  sellsCount: Scalars['Int']['output'];
  totalSellsPrice: Scalars['Float']['output'];
};

export type AnalysisCategoryDistributionLevel = {
  __typename?: 'AnalysisCategoryDistributionLevel';
  categories: Array<AnalysisCategoryDistribution>;
  level: Scalars['Int']['output'];
};

export type AnalysisNicheStats = {
  __typename?: 'AnalysisNicheStats';
  addedPerDay: Maybe<Scalars['Float']['output']>;
  avgPrice: Maybe<Scalars['Float']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  niche: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  soldPct: Maybe<Scalars['Float']['output']>;
  soldPerDay: Maybe<Scalars['Float']['output']>;
  timeToSellHours: Maybe<Scalars['Float']['output']>;
  type: AnalysisNicheStatsType;
};

export type AnalysisNicheStatsType =
  /** Brand niche type */
  | 'brand'
  /** Category niche type */
  | 'category'
  | '%future added value';

export type AnalysisQuota = {
  __typename?: 'AnalysisQuota';
  canCreateCatalogAnalysis: Scalars['Boolean']['output'];
  canCreateProfileAnalysis: Scalars['Boolean']['output'];
  catalogAnalysesAvailable: Scalars['Int']['output'];
  catalogAnalysesMax: Scalars['Int']['output'];
  catalogAnalysesUsed: Scalars['Int']['output'];
  hasFullPublicAnalysisAccess: Scalars['Boolean']['output'];
  hasPartialPublicAnalysisAccess: Scalars['Boolean']['output'];
  profileAnalysesAvailable: Scalars['Int']['output'];
  profileAnalysesMax: Scalars['Int']['output'];
  profileAnalysesUsed: Scalars['Int']['output'];
};

export type AnalysisStats = {
  __typename?: 'AnalysisStats';
  averageSalePrice: Maybe<Scalars['Float']['output']>;
  averageSaleTimeSec: Maybe<Scalars['Int']['output']>;
  newProductsPerDay: Maybe<Scalars['Int']['output']>;
  priceDistributionBuckets: Maybe<Array<PriceDistributionBucket>>;
  priceDistributionMax: Maybe<Scalars['Float']['output']>;
  priceDistributionMedian: Maybe<Scalars['Float']['output']>;
  priceDistributionMin: Maybe<Scalars['Float']['output']>;
  priceDistributionQ1: Maybe<Scalars['Float']['output']>;
  priceDistributionQ3: Maybe<Scalars['Float']['output']>;
  salePercentage: Maybe<Scalars['Float']['output']>;
  salesPerDay: Maybe<Scalars['Int']['output']>;
  totalProductsAnalyzed: Maybe<Scalars['Int']['output']>;
  totalSalesRecorded: Maybe<Scalars['Int']['output']>;
};

export type AnalysisStatus =
  /** Analysis is currently active and running */
  | 'active'
  /** Analysis encountered an error */
  | 'error'
  /** Analysis is paused or stopped */
  | 'inactive'
  /** Analysis has been soft deleted */
  | 'removed'
  /** Analysis is being initialized */
  | 'starting'
  | '%future added value';

export type AnalysisToUpdate = {
  __typename?: 'AnalysisToUpdate';
  id: Scalars['ID']['output'];
  lastScrapedProductVintedIds: Array<Scalars['String']['output']>;
  pageUrl: Scalars['String']['output'];
  type: AnalysisType;
};

export type AnalysisType =
  /** Search for products in catalog */
  | 'catalog'
  /** Search for products from a specific profile */
  | 'profile'
  | '%future added value';

export type CreateAnalysisAdminInput = {
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pageUrl: Scalars['String']['input'];
  publicCategoryId?: InputMaybe<Scalars['ID']['input']>;
  type: AnalysisType;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAnalysisInput = {
  name: Scalars['String']['input'];
  pageUrl: Scalars['String']['input'];
  type: AnalysisType;
};

export type CreatePublicAnalysisCategoryInput = {
  name: Scalars['String']['input'];
};

export type CreateStripeCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  periodicity: SubscriptionPlanPeriodicity;
  planId: Scalars['ID']['input'];
  successUrl: Scalars['String']['input'];
};

export type CreateStripeCheckoutSessionRes = {
  __typename?: 'CreateStripeCheckoutSessionRes';
  url: Scalars['String']['output'];
};

export type CreateStripePortalSessionInput = {
  returnUrl: Scalars['String']['input'];
  type: StripePortailType;
};

export type CreateStripePortalSessionRes = {
  __typename?: 'CreateStripePortalSessionRes';
  url: Scalars['String']['output'];
};

export type CreateSubscriptionPlanInput = {
  catalogAnalysisQuotas: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  isPublic: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  profileAnalysisQuotas: Scalars['Int']['input'];
  trialPeriodDays: Scalars['Int']['input'];
  userAllowlist?: Array<Scalars['String']['input']>;
};

export type CreateSubscriptionPlanPriceInput = {
  periodicity: SubscriptionPlanPricePeriodicity;
  planId: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  stripePriceId: Scalars['String']['input'];
};

export type GetOneAnalysisToUpdateResult = {
  __typename?: 'GetOneAnalysisToUpdateResult';
  analysis: AnalysisToUpdate;
  proxy: ScraperProxy;
};

export type GetOneProductToUpdateResult = {
  __typename?: 'GetOneProductToUpdateResult';
  product: ProductToUpdate;
  proxy: ScraperProxy;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAnalysis: Analysis;
  createAnalysisAdmin: Analysis;
  createPublicAnalysisCategory: PublicAnalysisCategory;
  /** Create a Stripe checkout session for subscription */
  createStripeCheckoutSession: CreateStripeCheckoutSessionRes;
  /** Create a Stripe portal session for managing subscription */
  createStripePortalSession: CreateStripePortalSessionRes;
  createSubscriptionPlanAdmin: SubscriptionPlanAdmin;
  createSubscriptionPlanPriceAdmin: SubscriptionPlanPrice;
  deactivateAnalysis: Analysis;
  deletePublicAnalysisCategory: Scalars['Boolean']['output'];
  deleteSubscriptionPlanAdmin: Scalars['Boolean']['output'];
  deleteSubscriptionPlanPriceAdmin: Scalars['Boolean']['output'];
  getOneAnalysisToUpdate: Maybe<GetOneAnalysisToUpdateResult>;
  getOneProductToUpdate: Maybe<GetOneProductToUpdateResult>;
  markAnalysisUpdateError: Scalars['Boolean']['output'];
  markAnalysisUpdateRetryable: Scalars['Boolean']['output'];
  markProductUpdateError: Scalars['Boolean']['output'];
  markProductUpdateRetryable: Scalars['Boolean']['output'];
  markProxyFailure: Scalars['Boolean']['output'];
  markProxySuccess: Scalars['Boolean']['output'];
  /** Rafraîchit les statistiques (analysisStats et analysisNichesStats) pour toutes les analyses (starting, active et optionnellement inactive) */
  refreshAllAnalysisStats: Scalars['Boolean']['output'];
  /** Rafraîchit les statistiques (analysisStats et analysisNichesStats) pour une analyse spécifique */
  refreshAnalysisStats: Scalars['Boolean']['output'];
  removeAnalysisAdmin: Scalars['Boolean']['output'];
  removeDeactivatedAnalysis: Scalars['Boolean']['output'];
  resetAnalysisNewSellsCounter: Analysis;
  updateAnalysisName: Analysis;
  updateAnalysisPublicCategory: Analysis;
  updateCatalogAnalysisItems: Scalars['Boolean']['output'];
  updateProfileAnalysisItems: Scalars['Boolean']['output'];
  updatePublicAnalysisCategory: PublicAnalysisCategory;
  updateSubscriptionPlanAdmin: SubscriptionPlanAdmin;
  updateSubscriptionPlanPriceAdmin: SubscriptionPlanPrice;
  upsertVintedItemWithSeller: Scalars['Boolean']['output'];
};


export type MutationCreateAnalysisArgs = {
  input: CreateAnalysisInput;
};


export type MutationCreateAnalysisAdminArgs = {
  input: CreateAnalysisAdminInput;
};


export type MutationCreatePublicAnalysisCategoryArgs = {
  input: CreatePublicAnalysisCategoryInput;
};


export type MutationCreateStripeCheckoutSessionArgs = {
  input: CreateStripeCheckoutSessionInput;
};


export type MutationCreateStripePortalSessionArgs = {
  input: CreateStripePortalSessionInput;
};


export type MutationCreateSubscriptionPlanAdminArgs = {
  input: CreateSubscriptionPlanInput;
};


export type MutationCreateSubscriptionPlanPriceAdminArgs = {
  input: CreateSubscriptionPlanPriceInput;
};


export type MutationDeactivateAnalysisArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePublicAnalysisCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubscriptionPlanAdminArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubscriptionPlanPriceAdminArgs = {
  stripePriceId: Scalars['ID']['input'];
};


export type MutationGetOneAnalysisToUpdateArgs = {
  analysisType: AnalysisType;
  currentProxyReservationId: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetOneProductToUpdateArgs = {
  currentProxyReservationId: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkAnalysisUpdateErrorArgs = {
  analysisId: Scalars['ID']['input'];
  errorMessage: Scalars['String']['input'];
};


export type MutationMarkAnalysisUpdateRetryableArgs = {
  analysisId: Scalars['ID']['input'];
};


export type MutationMarkProductUpdateErrorArgs = {
  errorMessage: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationMarkProductUpdateRetryableArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationMarkProxyFailureArgs = {
  errorMessage: Scalars['String']['input'];
  freeReservation?: InputMaybe<Scalars['Boolean']['input']>;
  reservationId: Scalars['String']['input'];
};


export type MutationMarkProxySuccessArgs = {
  freeReservation?: InputMaybe<Scalars['Boolean']['input']>;
  reservationId: Scalars['String']['input'];
};


export type MutationRefreshAllAnalysisStatsArgs = {
  refreshInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRefreshAnalysisStatsArgs = {
  analysisId: Scalars['ID']['input'];
};


export type MutationRemoveAnalysisAdminArgs = {
  analysisId: Scalars['ID']['input'];
};


export type MutationRemoveDeactivatedAnalysisArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetAnalysisNewSellsCounterArgs = {
  analysisId: Scalars['ID']['input'];
};


export type MutationUpdateAnalysisNameArgs = {
  input: UpdateAnalysisNameInput;
};


export type MutationUpdateAnalysisPublicCategoryArgs = {
  id: Scalars['ID']['input'];
  publicCategoryId: Scalars['ID']['input'];
};


export type MutationUpdateCatalogAnalysisItemsArgs = {
  input: UpdateCatalogAnalysisItemsInput;
  processingDurationSec: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateProfileAnalysisItemsArgs = {
  input: UpdateProfileAnalysisItemsInput;
  processingDurationSec: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdatePublicAnalysisCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePublicAnalysisCategoryInput;
};


export type MutationUpdateSubscriptionPlanAdminArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubscriptionPlanInput;
};


export type MutationUpdateSubscriptionPlanPriceAdminArgs = {
  input: UpdateSubscriptionPlanPriceInput;
  stripePriceId: Scalars['ID']['input'];
};


export type MutationUpsertVintedItemWithSellerArgs = {
  input: UpsertVintedItemWithSellerInput;
  processingDurationSec: InputMaybe<Scalars['Int']['input']>;
};

export type PaginatedAnalysis = {
  __typename?: 'PaginatedAnalysis';
  analyses: Array<Analysis>;
  hasNextPage: Scalars['Boolean']['output'];
  nextCursor: Maybe<Scalars['String']['output']>;
};

export type PaginatedProduct = {
  __typename?: 'PaginatedProduct';
  hasNextPage: Scalars['Boolean']['output'];
  nextCursor: Maybe<Scalars['String']['output']>;
  products: Array<Product>;
};

export type PriceDistributionBucket = {
  __typename?: 'PriceDistributionBucket';
  count: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
};

export type Product = {
  __typename?: 'Product';
  attributes: Maybe<Array<ProductAttribute>>;
  brand: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  favouriteCount: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images: Array<ProductImage>;
  inactivatedAt: Maybe<Scalars['DateTime']['output']>;
  isPromoted: Maybe<Scalars['Boolean']['output']>;
  itemCondition: Maybe<ProductItemCondition>;
  lastUpdateAt: Maybe<Scalars['DateTime']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  sellerName: Maybe<Scalars['String']['output']>;
  sellerRating: Maybe<Scalars['Float']['output']>;
  sellerReviews: Maybe<Scalars['Int']['output']>;
  sellerUrl: Maybe<Scalars['String']['output']>;
  status: ProductStatus;
  title: Scalars['String']['output'];
  uploadedAt: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductBrandCount = {
  __typename?: 'ProductBrandCount';
  brand: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  displayOrder: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type ProductItemCondition =
  /** Good condition (Bon) */
  | 'good'
  /** Good condition (Bon état) */
  | 'goodCondition'
  /** New with tag (Neuf avec étiquette) */
  | 'newWithTag'
  /** New without tag (Neuf sans étiquette) */
  | 'newWithoutTag'
  /** Satisfactory (Satisfaisant) */
  | 'satisfactory'
  /** Some pieces not working (Certaines pièces ne fonctionnent pas.) */
  | 'somePiecesNotWorking'
  /** Very good condition (Très bon état) */
  | 'veryGoodCondition'
  | '%future added value';

export type ProductItemConditionCount = {
  __typename?: 'ProductItemConditionCount';
  count: Scalars['Int']['output'];
  itemCondition: ProductItemCondition;
};

/** Options de tri pour les produits */
export type ProductSort =
  /** Du plus récent au plus ancien */
  | 'newest'
  /** Du plus ancien au plus récent */
  | 'oldest'
  /** Prix croissant */
  | 'priceAsc'
  /** Prix décroissant */
  | 'priceDesc'
  | '%future added value';

/** Statut du produit sur Vinted */
export type ProductStatus =
  /** Produit actif et disponible */
  | 'active'
  /** Produit réservé */
  | 'booked'
  /** Produit expiré */
  | 'expired'
  /** Vendeur en vacances */
  | 'holidays'
  /** Produit masqué */
  | 'masked'
  /** Produit retiré par le vendeur */
  | 'removed'
  /** Produit vendu */
  | 'sold'
  /** Statut inconnu */
  | 'unknown'
  | '%future added value';

export type ProductToUpdate = {
  __typename?: 'ProductToUpdate';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
  vintedId: Scalars['String']['output'];
};

export type PublicAnalysisCategory = {
  __typename?: 'PublicAnalysisCategory';
  analyses: Array<Analysis>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAllPublicAnalysisCategories: Array<PublicAnalysisCategory>;
  getAllSubscriptionPlansAdmin: Array<SubscriptionPlanAdmin>;
  getAnalysisBrandDistribution: Array<AnalysisBrandDistribution>;
  getAnalysisById: Maybe<Analysis>;
  getAnalysisCategoriesLevelsDistribution: Array<AnalysisCategoryDistributionLevel>;
  getAnalysisNiches: Array<AnalysisNicheStats>;
  getAnalysisStats: AnalysisStats;
  getAvailableBrands: Array<ProductBrandCount>;
  getAvailableItemConditions: Array<ProductItemConditionCount>;
  /** Get all available subscription plans */
  getAvailableSubscriptionPlans: Array<SubscriptionPlan>;
  getCurrentUserAnalysisQuotas: AnalysisQuota;
  getCurrentUserAnalysisStats: UserAnalysisStats;
  /** Get current user subscription */
  getCurrentUserSubscription: Maybe<UserSubscription>;
  getNicheSoldProducts: Array<Product>;
  getProductById: Maybe<Product>;
  getProductFeed: PaginatedProduct;
  getProductsByStatus: Array<Product>;
  getPublicAnalysesByCategory: Array<Analysis>;
  getPublicAnalysisCategories: Array<PublicAnalysisCategory>;
  getPublicAnalysisCategoryById: Maybe<PublicAnalysisCategory>;
  getUserAnalysesPaginated: PaginatedAnalysis;
  getUserAnalysisQuotas: AnalysisQuota;
  getUserAnalysisStats: UserAnalysisStats;
  /** Génère un CSV avec les statistiques de toutes les analyses de l'utilisateur (limité à 1000 analyses, triées par date de création décroissante) */
  getUserAnalysisStatsCsv: Scalars['String']['output'];
  getUserSubscriptionAdmin: Maybe<UserSubscriptionAdmin>;
};


export type QueryGetAnalysisBrandDistributionArgs = {
  analysisId: Scalars['ID']['input'];
  categoryPath: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAnalysisByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAnalysisCategoriesLevelsDistributionArgs = {
  analysisId: Scalars['ID']['input'];
};


export type QueryGetAnalysisNichesArgs = {
  analysisId: Scalars['ID']['input'];
};


export type QueryGetAnalysisStatsArgs = {
  analysisId: Scalars['ID']['input'];
  itemCondition: InputMaybe<ProductItemCondition>;
};


export type QueryGetAvailableBrandsArgs = {
  analysisId: Scalars['ID']['input'];
  status: InputMaybe<ProductStatus>;
};


export type QueryGetAvailableItemConditionsArgs = {
  analysisId: Scalars['ID']['input'];
  status: InputMaybe<ProductStatus>;
};


export type QueryGetNicheSoldProductsArgs = {
  analysisId: Scalars['ID']['input'];
  brandOrFullPath: Scalars['String']['input'];
};


export type QueryGetProductByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProductFeedArgs = {
  analysisId: Scalars['ID']['input'];
  brand: InputMaybe<Scalars['String']['input']>;
  cursor: InputMaybe<Scalars['String']['input']>;
  itemCondition: InputMaybe<ProductItemCondition>;
  limit: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<ProductSort>;
  status: InputMaybe<ProductStatus>;
};


export type QueryGetProductsByStatusArgs = {
  analysisId: Scalars['ID']['input'];
  status: ProductStatus;
};


export type QueryGetPublicAnalysesByCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryGetPublicAnalysisCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserAnalysesPaginatedArgs = {
  cursor: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  type: AnalysisType;
};


export type QueryGetUserAnalysisQuotasArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUserAnalysisStatsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUserSubscriptionAdminArgs = {
  stripeCustomerId: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Scalars['ID']['input']>;
};

export type ScraperProxy = {
  __typename?: 'ScraperProxy';
  host: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  password: Maybe<Scalars['String']['output']>;
  port: Scalars['Int']['output'];
  protocol: Scalars['String']['output'];
  reservationExpiresAt: Scalars['DateTime']['output'];
  reservationId: Scalars['String']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type StripePortailType =
  /** Manage payment method and invoices */
  | 'paymentMethodAndInvoices'
  /** Cancel subscription */
  | 'subscriptionCancel'
  | '%future added value';

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  catalogAnalysisQuotas: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceMonthly: Maybe<Scalars['Float']['output']>;
  priceYearly: Maybe<Scalars['Float']['output']>;
  profileAnalysisQuotas: Scalars['Int']['output'];
  trialPeriodDays: Scalars['Int']['output'];
};

export type SubscriptionPlanAdmin = {
  __typename?: 'SubscriptionPlanAdmin';
  catalogAnalysisQuotas: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prices: Array<SubscriptionPlanPrice>;
  profileAnalysisQuotas: Scalars['Int']['output'];
  trialPeriodDays: Scalars['Int']['output'];
  userAllowlist: Array<Scalars['String']['output']>;
};

export type SubscriptionPlanPeriodicity =
  /** Monthly subscription plan */
  | 'monthly'
  /** Yearly subscription plan */
  | 'yearly'
  | '%future added value';

export type SubscriptionPlanPrice = {
  __typename?: 'SubscriptionPlanPrice';
  periodicity: SubscriptionPlanPricePeriodicity;
  planId: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  stripePriceId: Scalars['ID']['output'];
};

/** Périodicité du prix du plan d'abonnement */
export type SubscriptionPlanPricePeriodicity =
  /** Abonnement mensuel */
  | 'monthly'
  /** Abonnement annuel */
  | 'yearly'
  | '%future added value';

export type UpdateAnalysisNameInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCatalogAnalysisItemsInput = {
  analysisId: Scalars['ID']['input'];
  items: Array<UpsertVintedItemWithSellerInput>;
};

export type UpdateProfileAnalysisItemsInput = {
  analysisId: Scalars['ID']['input'];
  items: Array<UpsertVintedItemInput>;
  seller?: InputMaybe<UpsertVintedSellerInput>;
};

export type UpdatePublicAnalysisCategoryInput = {
  name: Scalars['String']['input'];
};

export type UpdateSubscriptionPlanInput = {
  catalogAnalysisQuotas?: InputMaybe<Scalars['Int']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileAnalysisQuotas?: InputMaybe<Scalars['Int']['input']>;
  trialPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  userAllowlist?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSubscriptionPlanPriceInput = {
  periodicity?: InputMaybe<SubscriptionPlanPricePeriodicity>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertVintedItemAttributeInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
  vintedId?: InputMaybe<Scalars['Float']['input']>;
  vintedUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertVintedItemImageInput = {
  displayOrder: Scalars['Float']['input'];
  url: Scalars['String']['input'];
};

export type UpsertVintedItemInput = {
  attributes?: InputMaybe<Array<UpsertVintedItemAttributeInput>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  favouriteCount?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Array<UpsertVintedItemImageInput>>;
  isPromoted?: InputMaybe<Scalars['Boolean']['input']>;
  itemCondition?: InputMaybe<ProductItemCondition>;
  price?: InputMaybe<Scalars['Float']['input']>;
  seller?: InputMaybe<UpsertVintedSellerInput>;
  serviceFee?: InputMaybe<Scalars['Float']['input']>;
  siteCategories?: InputMaybe<Array<UpsertVintedItemSiteCategoryInput>>;
  status?: InputMaybe<ProductStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vintedId: Scalars['String']['input'];
};

export type UpsertVintedItemSiteCategoryInput = {
  fullPath: Scalars['String']['input'];
  level: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpsertVintedItemWithSellerInput = {
  item: UpsertVintedItemInput;
  seller?: InputMaybe<UpsertVintedSellerInput>;
};

export type UpsertVintedSellerInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  allowDirectMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  business?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  feedbackCount?: InputMaybe<Scalars['Int']['input']>;
  feedbackRating?: InputMaybe<Scalars['Float']['input']>;
  followersCount?: InputMaybe<Scalars['Int']['input']>;
  followingCount?: InputMaybe<Scalars['Int']['input']>;
  hideFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isAccountBanned?: InputMaybe<Scalars['Boolean']['input']>;
  isOnHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoggedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  moderator?: InputMaybe<Scalars['Boolean']['input']>;
  negativeFeedbackCount?: InputMaybe<Scalars['Int']['input']>;
  neutralFeedbackCount?: InputMaybe<Scalars['Int']['input']>;
  positiveFeedbackCount?: InputMaybe<Scalars['Int']['input']>;
  sellerBadges?: InputMaybe<Array<Scalars['String']['input']>>;
  totalItemsCount?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  vintedId: Scalars['String']['input'];
};

export type UserAnalysisStats = {
  __typename?: 'UserAnalysisStats';
  activeDays: Scalars['Int']['output'];
  catalogAnalyses: Scalars['Int']['output'];
  catalogAnalysesPerWeek: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  profileAnalyses: Scalars['Int']['output'];
  profileAnalysesPerWeek: Scalars['Float']['output'];
  totalAnalyses: Scalars['Int']['output'];
  totalAnalysesPerWeek: Scalars['Float']['output'];
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  inactivatedAt: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  plan: Maybe<UserSubscriptionPlan>;
};

export type UserSubscriptionAdmin = {
  __typename?: 'UserSubscriptionAdmin';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  inactivatedAt: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  nextRenewalAt: Maybe<Scalars['DateTime']['output']>;
  stripeCustomerId: Scalars['String']['output'];
  stripePriceId: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type UserSubscriptionPlan = {
  __typename?: 'UserSubscriptionPlan';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextRenewalAt: Maybe<Scalars['DateTime']['output']>;
  periodicity: SubscriptionPlanPeriodicity;
  price: Scalars['Float']['output'];
};

export type AnalysisBaseFragment = { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, status: AnalysisStatus, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, lastUpdatedAt: string | null | undefined, inactivatedAt: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, newSells: number | null | undefined };

export type ProductBaseFragment = { __typename?: 'Product', id: string, url: string, title: string, description: string | null | undefined, price: number | null | undefined, status: ProductStatus, itemCondition: ProductItemCondition | null | undefined, brand: string | null | undefined, favouriteCount: number | null | undefined, sellerUrl: string | null | undefined, sellerName: string | null | undefined, sellerReviews: number | null | undefined, sellerRating: number | null | undefined, uploadedAt: string | null | undefined, inactivatedAt: string | null | undefined, lastUpdateAt: string | null | undefined, createdAt: string, attributes: Array<{ __typename?: 'ProductAttribute', key: string, name: string, value: string }> | null | undefined, images: Array<{ __typename?: 'ProductImage', url: string, displayOrder: number }> };

export type CreateAnalysisMutationVariables = Exact<{
  input: CreateAnalysisInput;
}>;


export type CreateAnalysisMutation = { __typename?: 'Mutation', createAnalysis: { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, status: AnalysisStatus, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, lastUpdatedAt: string | null | undefined, inactivatedAt: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, newSells: number | null | undefined } };

export type DeactivateAnalysisMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateAnalysisMutation = { __typename?: 'Mutation', deactivateAnalysis: { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, status: AnalysisStatus, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, lastUpdatedAt: string | null | undefined, inactivatedAt: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, newSells: number | null | undefined } };

export type RemoveDeactivatedAnalysisMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveDeactivatedAnalysisMutation = { __typename?: 'Mutation', removeDeactivatedAnalysis: boolean };

export type UpdateAnalysisNameMutationVariables = Exact<{
  input: UpdateAnalysisNameInput;
}>;


export type UpdateAnalysisNameMutation = { __typename?: 'Mutation', updateAnalysisName: { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, status: AnalysisStatus, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, lastUpdatedAt: string | null | undefined, inactivatedAt: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, newSells: number | null | undefined } };

export type ResetAnalysisNewSellsCounterMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type ResetAnalysisNewSellsCounterMutation = { __typename?: 'Mutation', resetAnalysisNewSellsCounter: { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, status: AnalysisStatus, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, lastUpdatedAt: string | null | undefined, inactivatedAt: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, newSells: number | null | undefined } };

export type CreateStripeCheckoutSessionMutationVariables = Exact<{
  input: CreateStripeCheckoutSessionInput;
}>;


export type CreateStripeCheckoutSessionMutation = { __typename?: 'Mutation', createStripeCheckoutSession: { __typename?: 'CreateStripeCheckoutSessionRes', url: string } };

export type CreateStripePortalSessionMutationVariables = Exact<{
  input: CreateStripePortalSessionInput;
}>;


export type CreateStripePortalSessionMutation = { __typename?: 'Mutation', createStripePortalSession: { __typename?: 'CreateStripePortalSessionRes', url: string } };

export type GetAnalysisStatsQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  itemCondition: InputMaybe<ProductItemCondition>;
}>;


export type GetAnalysisStatsQuery = { __typename?: 'Query', getAnalysisStats: { __typename?: 'AnalysisStats', averageSalePrice: number | null | undefined, salePercentage: number | null | undefined, averageSaleTimeSec: number | null | undefined, totalProductsAnalyzed: number | null | undefined, totalSalesRecorded: number | null | undefined, newProductsPerDay: number | null | undefined, salesPerDay: number | null | undefined, priceDistributionQ1: number | null | undefined, priceDistributionQ3: number | null | undefined, priceDistributionMin: number | null | undefined, priceDistributionMax: number | null | undefined, priceDistributionBuckets: Array<{ __typename?: 'PriceDistributionBucket', price: number, count: number }> | null | undefined } };

export type GetAnalysisNichesQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type GetAnalysisNichesQuery = { __typename?: 'Query', getAnalysisNiches: Array<{ __typename?: 'AnalysisNicheStats', type: AnalysisNicheStatsType, niche: string, imageUrl: string | null | undefined, avgPrice: number | null | undefined, productCount: number, soldPct: number | null | undefined, soldPerDay: number | null | undefined, addedPerDay: number | null | undefined, timeToSellHours: number | null | undefined }> };

export type GetUserAnalysisStatsCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAnalysisStatsCsvQuery = { __typename?: 'Query', getUserAnalysisStatsCsv: string };

export type GetAnalysisByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAnalysisByIdQuery = { __typename?: 'Query', getAnalysisById: { __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, status: AnalysisStatus, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, lastUpdatedAt: string | null | undefined, inactivatedAt: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, newSells: number | null | undefined } | null | undefined };

export type GetUserAnalysesPaginatedQueryVariables = Exact<{
  type: AnalysisType;
  cursor: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserAnalysesPaginatedQuery = { __typename?: 'Query', getUserAnalysesPaginated: { __typename?: 'PaginatedAnalysis', nextCursor: string | null | undefined, hasNextPage: boolean, analyses: Array<{ __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, status: AnalysisStatus, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, lastUpdatedAt: string | null | undefined, inactivatedAt: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, newSells: number | null | undefined }> } };

export type GetPublicAnalysisCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicAnalysisCategoriesQuery = { __typename?: 'Query', getPublicAnalysisCategories: Array<{ __typename?: 'PublicAnalysisCategory', id: string, name: string, analyses: Array<{ __typename?: 'Analysis', id: string, name: string, pageUrl: string, imageUrl: string | null | undefined, type: AnalysisType, status: AnalysisStatus, isPublic: boolean, userId: string | null | undefined, publicCategoryId: string | null | undefined, lastUpdatedAt: string | null | undefined, inactivatedAt: string | null | undefined, createdAt: string, analysedProductCount: number | null | undefined, newSells: number | null | undefined }> }> };

export type GetAnalysisBrandDistributionQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  categoryPath: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnalysisBrandDistributionQuery = { __typename?: 'Query', getAnalysisBrandDistribution: Array<{ __typename?: 'AnalysisBrandDistribution', brand: string, sellsCount: number, totalSellsPrice: number, avgSellsPrice: number }> };

export type GetAnalysisCategoriesLevelsDistributionQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type GetAnalysisCategoriesLevelsDistributionQuery = { __typename?: 'Query', getAnalysisCategoriesLevelsDistribution: Array<{ __typename?: 'AnalysisCategoryDistributionLevel', level: number, categories: Array<{ __typename?: 'AnalysisCategoryDistribution', categoryName: string, fullPath: string, level: number, sellsCount: number, totalSellsPrice: number, avgSellsPrice: number }> }> };

export type GetProductByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductByIdQuery = { __typename?: 'Query', getProductById: { __typename?: 'Product', id: string, url: string, title: string, description: string | null | undefined, price: number | null | undefined, status: ProductStatus, itemCondition: ProductItemCondition | null | undefined, brand: string | null | undefined, favouriteCount: number | null | undefined, sellerUrl: string | null | undefined, sellerName: string | null | undefined, sellerReviews: number | null | undefined, sellerRating: number | null | undefined, uploadedAt: string | null | undefined, inactivatedAt: string | null | undefined, lastUpdateAt: string | null | undefined, createdAt: string, attributes: Array<{ __typename?: 'ProductAttribute', key: string, name: string, value: string }> | null | undefined, images: Array<{ __typename?: 'ProductImage', url: string, displayOrder: number }> } | null | undefined };

export type GetAvailableBrandsQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  status: InputMaybe<ProductStatus>;
}>;


export type GetAvailableBrandsQuery = { __typename?: 'Query', getAvailableBrands: Array<{ __typename?: 'ProductBrandCount', brand: string, count: number }> };

export type GetAvailableItemConditionsQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  status: InputMaybe<ProductStatus>;
}>;


export type GetAvailableItemConditionsQuery = { __typename?: 'Query', getAvailableItemConditions: Array<{ __typename?: 'ProductItemConditionCount', itemCondition: ProductItemCondition, count: number }> };

export type GetProductsByStatusQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  status: ProductStatus;
}>;


export type GetProductsByStatusQuery = { __typename?: 'Query', getProductsByStatus: Array<{ __typename?: 'Product', id: string, url: string, title: string, description: string | null | undefined, price: number | null | undefined, status: ProductStatus, itemCondition: ProductItemCondition | null | undefined, brand: string | null | undefined, favouriteCount: number | null | undefined, sellerUrl: string | null | undefined, sellerName: string | null | undefined, sellerReviews: number | null | undefined, sellerRating: number | null | undefined, uploadedAt: string | null | undefined, inactivatedAt: string | null | undefined, lastUpdateAt: string | null | undefined, createdAt: string, attributes: Array<{ __typename?: 'ProductAttribute', key: string, name: string, value: string }> | null | undefined, images: Array<{ __typename?: 'ProductImage', url: string, displayOrder: number }> }> };

export type GetNicheSoldProductsQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  brandOrFullPath: Scalars['String']['input'];
}>;


export type GetNicheSoldProductsQuery = { __typename?: 'Query', getNicheSoldProducts: Array<{ __typename?: 'Product', id: string, url: string, title: string, description: string | null | undefined, price: number | null | undefined, status: ProductStatus, itemCondition: ProductItemCondition | null | undefined, brand: string | null | undefined, favouriteCount: number | null | undefined, sellerUrl: string | null | undefined, sellerName: string | null | undefined, sellerReviews: number | null | undefined, sellerRating: number | null | undefined, uploadedAt: string | null | undefined, inactivatedAt: string | null | undefined, lastUpdateAt: string | null | undefined, createdAt: string, attributes: Array<{ __typename?: 'ProductAttribute', key: string, name: string, value: string }> | null | undefined, images: Array<{ __typename?: 'ProductImage', url: string, displayOrder: number }> }> };

export type GetAvailableSubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableSubscriptionPlansQuery = { __typename?: 'Query', getAvailableSubscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, name: string, isPublic: boolean, priceMonthly: number | null | undefined, priceYearly: number | null | undefined, catalogAnalysisQuotas: number, profileAnalysisQuotas: number, trialPeriodDays: number }> };

export type GetCurrentUserSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserSubscriptionQuery = { __typename?: 'Query', getCurrentUserSubscription: { __typename?: 'UserSubscription', isActive: boolean, inactivatedAt: string | null | undefined, plan: { __typename?: 'UserSubscriptionPlan', id: string, name: string, periodicity: SubscriptionPlanPeriodicity, price: number, nextRenewalAt: string | null | undefined } | null | undefined } | null | undefined };

export type GetCurrentUserAnalysisQuotasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserAnalysisQuotasQuery = { __typename?: 'Query', getCurrentUserAnalysisQuotas: { __typename?: 'AnalysisQuota', hasPartialPublicAnalysisAccess: boolean, hasFullPublicAnalysisAccess: boolean, catalogAnalysesUsed: number, catalogAnalysesMax: number, catalogAnalysesAvailable: number, profileAnalysesUsed: number, profileAnalysesMax: number, profileAnalysesAvailable: number, canCreateCatalogAnalysis: boolean, canCreateProfileAnalysis: boolean } };


export const AnalysisBaseFragmentDoc = `
    fragment AnalysisBase on Analysis {
  id
  name
  pageUrl
  imageUrl
  type
  status
  isPublic
  userId
  publicCategoryId
  lastUpdatedAt
  inactivatedAt
  createdAt
  analysedProductCount
  newSells
}
    `;
export const ProductBaseFragmentDoc = `
    fragment ProductBase on Product {
  id
  url
  title
  description
  price
  status
  itemCondition
  brand
  favouriteCount
  attributes {
    key
    name
    value
  }
  sellerUrl
  sellerName
  sellerReviews
  sellerRating
  uploadedAt
  inactivatedAt
  lastUpdateAt
  createdAt
  images {
    url
    displayOrder
  }
}
    `;
export const CreateAnalysisDocument = `
    mutation CreateAnalysis($input: CreateAnalysisInput!) {
  createAnalysis(input: $input) {
    ...AnalysisBase
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useCreateAnalysisMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAnalysisMutation, TError, CreateAnalysisMutationVariables, TContext>) => {
    
    return useMutation<CreateAnalysisMutation, TError, CreateAnalysisMutationVariables, TContext>(
      {
    mutationKey: ['CreateAnalysis'],
    mutationFn: (variables?: CreateAnalysisMutationVariables) => graphqlClient<CreateAnalysisMutation, CreateAnalysisMutationVariables>(CreateAnalysisDocument, variables)(),
    ...options
  }
    )};

useCreateAnalysisMutation.getKey = () => ['CreateAnalysis'];


useCreateAnalysisMutation.fetcher = (variables: CreateAnalysisMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateAnalysisMutation, CreateAnalysisMutationVariables>(CreateAnalysisDocument, variables, options);

export const DeactivateAnalysisDocument = `
    mutation DeactivateAnalysis($id: ID!) {
  deactivateAnalysis(id: $id) {
    ...AnalysisBase
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useDeactivateAnalysisMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeactivateAnalysisMutation, TError, DeactivateAnalysisMutationVariables, TContext>) => {
    
    return useMutation<DeactivateAnalysisMutation, TError, DeactivateAnalysisMutationVariables, TContext>(
      {
    mutationKey: ['DeactivateAnalysis'],
    mutationFn: (variables?: DeactivateAnalysisMutationVariables) => graphqlClient<DeactivateAnalysisMutation, DeactivateAnalysisMutationVariables>(DeactivateAnalysisDocument, variables)(),
    ...options
  }
    )};

useDeactivateAnalysisMutation.getKey = () => ['DeactivateAnalysis'];


useDeactivateAnalysisMutation.fetcher = (variables: DeactivateAnalysisMutationVariables, options?: RequestInit['headers']) => graphqlClient<DeactivateAnalysisMutation, DeactivateAnalysisMutationVariables>(DeactivateAnalysisDocument, variables, options);

export const RemoveDeactivatedAnalysisDocument = `
    mutation RemoveDeactivatedAnalysis($id: ID!) {
  removeDeactivatedAnalysis(id: $id)
}
    `;

export const useRemoveDeactivatedAnalysisMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveDeactivatedAnalysisMutation, TError, RemoveDeactivatedAnalysisMutationVariables, TContext>) => {
    
    return useMutation<RemoveDeactivatedAnalysisMutation, TError, RemoveDeactivatedAnalysisMutationVariables, TContext>(
      {
    mutationKey: ['RemoveDeactivatedAnalysis'],
    mutationFn: (variables?: RemoveDeactivatedAnalysisMutationVariables) => graphqlClient<RemoveDeactivatedAnalysisMutation, RemoveDeactivatedAnalysisMutationVariables>(RemoveDeactivatedAnalysisDocument, variables)(),
    ...options
  }
    )};

useRemoveDeactivatedAnalysisMutation.getKey = () => ['RemoveDeactivatedAnalysis'];


useRemoveDeactivatedAnalysisMutation.fetcher = (variables: RemoveDeactivatedAnalysisMutationVariables, options?: RequestInit['headers']) => graphqlClient<RemoveDeactivatedAnalysisMutation, RemoveDeactivatedAnalysisMutationVariables>(RemoveDeactivatedAnalysisDocument, variables, options);

export const UpdateAnalysisNameDocument = `
    mutation UpdateAnalysisName($input: UpdateAnalysisNameInput!) {
  updateAnalysisName(input: $input) {
    ...AnalysisBase
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useUpdateAnalysisNameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAnalysisNameMutation, TError, UpdateAnalysisNameMutationVariables, TContext>) => {
    
    return useMutation<UpdateAnalysisNameMutation, TError, UpdateAnalysisNameMutationVariables, TContext>(
      {
    mutationKey: ['UpdateAnalysisName'],
    mutationFn: (variables?: UpdateAnalysisNameMutationVariables) => graphqlClient<UpdateAnalysisNameMutation, UpdateAnalysisNameMutationVariables>(UpdateAnalysisNameDocument, variables)(),
    ...options
  }
    )};

useUpdateAnalysisNameMutation.getKey = () => ['UpdateAnalysisName'];


useUpdateAnalysisNameMutation.fetcher = (variables: UpdateAnalysisNameMutationVariables, options?: RequestInit['headers']) => graphqlClient<UpdateAnalysisNameMutation, UpdateAnalysisNameMutationVariables>(UpdateAnalysisNameDocument, variables, options);

export const ResetAnalysisNewSellsCounterDocument = `
    mutation ResetAnalysisNewSellsCounter($analysisId: ID!) {
  resetAnalysisNewSellsCounter(analysisId: $analysisId) {
    ...AnalysisBase
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useResetAnalysisNewSellsCounterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResetAnalysisNewSellsCounterMutation, TError, ResetAnalysisNewSellsCounterMutationVariables, TContext>) => {
    
    return useMutation<ResetAnalysisNewSellsCounterMutation, TError, ResetAnalysisNewSellsCounterMutationVariables, TContext>(
      {
    mutationKey: ['ResetAnalysisNewSellsCounter'],
    mutationFn: (variables?: ResetAnalysisNewSellsCounterMutationVariables) => graphqlClient<ResetAnalysisNewSellsCounterMutation, ResetAnalysisNewSellsCounterMutationVariables>(ResetAnalysisNewSellsCounterDocument, variables)(),
    ...options
  }
    )};

useResetAnalysisNewSellsCounterMutation.getKey = () => ['ResetAnalysisNewSellsCounter'];


useResetAnalysisNewSellsCounterMutation.fetcher = (variables: ResetAnalysisNewSellsCounterMutationVariables, options?: RequestInit['headers']) => graphqlClient<ResetAnalysisNewSellsCounterMutation, ResetAnalysisNewSellsCounterMutationVariables>(ResetAnalysisNewSellsCounterDocument, variables, options);

export const CreateStripeCheckoutSessionDocument = `
    mutation CreateStripeCheckoutSession($input: CreateStripeCheckoutSessionInput!) {
  createStripeCheckoutSession(input: $input) {
    url
  }
}
    `;

export const useCreateStripeCheckoutSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateStripeCheckoutSessionMutation, TError, CreateStripeCheckoutSessionMutationVariables, TContext>) => {
    
    return useMutation<CreateStripeCheckoutSessionMutation, TError, CreateStripeCheckoutSessionMutationVariables, TContext>(
      {
    mutationKey: ['CreateStripeCheckoutSession'],
    mutationFn: (variables?: CreateStripeCheckoutSessionMutationVariables) => graphqlClient<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>(CreateStripeCheckoutSessionDocument, variables)(),
    ...options
  }
    )};

useCreateStripeCheckoutSessionMutation.getKey = () => ['CreateStripeCheckoutSession'];


useCreateStripeCheckoutSessionMutation.fetcher = (variables: CreateStripeCheckoutSessionMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>(CreateStripeCheckoutSessionDocument, variables, options);

export const CreateStripePortalSessionDocument = `
    mutation CreateStripePortalSession($input: CreateStripePortalSessionInput!) {
  createStripePortalSession(input: $input) {
    url
  }
}
    `;

export const useCreateStripePortalSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateStripePortalSessionMutation, TError, CreateStripePortalSessionMutationVariables, TContext>) => {
    
    return useMutation<CreateStripePortalSessionMutation, TError, CreateStripePortalSessionMutationVariables, TContext>(
      {
    mutationKey: ['CreateStripePortalSession'],
    mutationFn: (variables?: CreateStripePortalSessionMutationVariables) => graphqlClient<CreateStripePortalSessionMutation, CreateStripePortalSessionMutationVariables>(CreateStripePortalSessionDocument, variables)(),
    ...options
  }
    )};

useCreateStripePortalSessionMutation.getKey = () => ['CreateStripePortalSession'];


useCreateStripePortalSessionMutation.fetcher = (variables: CreateStripePortalSessionMutationVariables, options?: RequestInit['headers']) => graphqlClient<CreateStripePortalSessionMutation, CreateStripePortalSessionMutationVariables>(CreateStripePortalSessionDocument, variables, options);

export const GetAnalysisStatsDocument = `
    query GetAnalysisStats($analysisId: ID!, $itemCondition: ProductItemCondition) {
  getAnalysisStats(analysisId: $analysisId, itemCondition: $itemCondition) {
    averageSalePrice
    salePercentage
    averageSaleTimeSec
    totalProductsAnalyzed
    totalSalesRecorded
    newProductsPerDay
    salesPerDay
    priceDistributionQ1
    priceDistributionQ3
    priceDistributionMin
    priceDistributionMax
    priceDistributionBuckets {
      price
      count
    }
  }
}
    `;

export const useGetAnalysisStatsQuery = <
      TData = GetAnalysisStatsQuery,
      TError = unknown
    >(
      variables: GetAnalysisStatsQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisStatsQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisStats', variables],
    queryFn: graphqlClient<GetAnalysisStatsQuery, GetAnalysisStatsQueryVariables>(GetAnalysisStatsDocument, variables),
    ...options
  }
    )};

useGetAnalysisStatsQuery.getKey = (variables: GetAnalysisStatsQueryVariables) => ['GetAnalysisStats', variables];

export const useInfiniteGetAnalysisStatsQuery = <
      TData = InfiniteData<GetAnalysisStatsQuery>,
      TError = unknown
    >(
      variables: GetAnalysisStatsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisStatsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisStats.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisStatsQuery, GetAnalysisStatsQueryVariables>(GetAnalysisStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisStatsQuery.getKey = (variables: GetAnalysisStatsQueryVariables) => ['GetAnalysisStats.infinite', variables];


useGetAnalysisStatsQuery.fetcher = (variables: GetAnalysisStatsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisStatsQuery, GetAnalysisStatsQueryVariables>(GetAnalysisStatsDocument, variables, options);

export const GetAnalysisNichesDocument = `
    query GetAnalysisNiches($analysisId: ID!) {
  getAnalysisNiches(analysisId: $analysisId) {
    type
    niche
    imageUrl
    avgPrice
    productCount
    soldPct
    soldPerDay
    addedPerDay
    timeToSellHours
  }
}
    `;

export const useGetAnalysisNichesQuery = <
      TData = GetAnalysisNichesQuery,
      TError = unknown
    >(
      variables: GetAnalysisNichesQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisNichesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisNichesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisNichesQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisNiches', variables],
    queryFn: graphqlClient<GetAnalysisNichesQuery, GetAnalysisNichesQueryVariables>(GetAnalysisNichesDocument, variables),
    ...options
  }
    )};

useGetAnalysisNichesQuery.getKey = (variables: GetAnalysisNichesQueryVariables) => ['GetAnalysisNiches', variables];

export const useInfiniteGetAnalysisNichesQuery = <
      TData = InfiniteData<GetAnalysisNichesQuery>,
      TError = unknown
    >(
      variables: GetAnalysisNichesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisNichesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisNichesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisNichesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisNiches.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisNichesQuery, GetAnalysisNichesQueryVariables>(GetAnalysisNichesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisNichesQuery.getKey = (variables: GetAnalysisNichesQueryVariables) => ['GetAnalysisNiches.infinite', variables];


useGetAnalysisNichesQuery.fetcher = (variables: GetAnalysisNichesQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisNichesQuery, GetAnalysisNichesQueryVariables>(GetAnalysisNichesDocument, variables, options);

export const GetUserAnalysisStatsCsvDocument = `
    query GetUserAnalysisStatsCsv {
  getUserAnalysisStatsCsv
}
    `;

export const useGetUserAnalysisStatsCsvQuery = <
      TData = GetUserAnalysisStatsCsvQuery,
      TError = unknown
    >(
      variables?: GetUserAnalysisStatsCsvQueryVariables,
      options?: Omit<UseQueryOptions<GetUserAnalysisStatsCsvQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserAnalysisStatsCsvQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserAnalysisStatsCsvQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserAnalysisStatsCsv'] : ['GetUserAnalysisStatsCsv', variables],
    queryFn: graphqlClient<GetUserAnalysisStatsCsvQuery, GetUserAnalysisStatsCsvQueryVariables>(GetUserAnalysisStatsCsvDocument, variables),
    ...options
  }
    )};

useGetUserAnalysisStatsCsvQuery.getKey = (variables?: GetUserAnalysisStatsCsvQueryVariables) => variables === undefined ? ['GetUserAnalysisStatsCsv'] : ['GetUserAnalysisStatsCsv', variables];

export const useInfiniteGetUserAnalysisStatsCsvQuery = <
      TData = InfiniteData<GetUserAnalysisStatsCsvQuery>,
      TError = unknown
    >(
      variables: GetUserAnalysisStatsCsvQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserAnalysisStatsCsvQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserAnalysisStatsCsvQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserAnalysisStatsCsvQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetUserAnalysisStatsCsv.infinite'] : ['GetUserAnalysisStatsCsv.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetUserAnalysisStatsCsvQuery, GetUserAnalysisStatsCsvQueryVariables>(GetUserAnalysisStatsCsvDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserAnalysisStatsCsvQuery.getKey = (variables?: GetUserAnalysisStatsCsvQueryVariables) => variables === undefined ? ['GetUserAnalysisStatsCsv.infinite'] : ['GetUserAnalysisStatsCsv.infinite', variables];


useGetUserAnalysisStatsCsvQuery.fetcher = (variables?: GetUserAnalysisStatsCsvQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetUserAnalysisStatsCsvQuery, GetUserAnalysisStatsCsvQueryVariables>(GetUserAnalysisStatsCsvDocument, variables, options);

export const GetAnalysisByIdDocument = `
    query GetAnalysisById($id: ID!) {
  getAnalysisById(id: $id) {
    ...AnalysisBase
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useGetAnalysisByIdQuery = <
      TData = GetAnalysisByIdQuery,
      TError = unknown
    >(
      variables: GetAnalysisByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisByIdQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisById', variables],
    queryFn: graphqlClient<GetAnalysisByIdQuery, GetAnalysisByIdQueryVariables>(GetAnalysisByIdDocument, variables),
    ...options
  }
    )};

useGetAnalysisByIdQuery.getKey = (variables: GetAnalysisByIdQueryVariables) => ['GetAnalysisById', variables];

export const useInfiniteGetAnalysisByIdQuery = <
      TData = InfiniteData<GetAnalysisByIdQuery>,
      TError = unknown
    >(
      variables: GetAnalysisByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisById.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisByIdQuery, GetAnalysisByIdQueryVariables>(GetAnalysisByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisByIdQuery.getKey = (variables: GetAnalysisByIdQueryVariables) => ['GetAnalysisById.infinite', variables];


useGetAnalysisByIdQuery.fetcher = (variables: GetAnalysisByIdQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisByIdQuery, GetAnalysisByIdQueryVariables>(GetAnalysisByIdDocument, variables, options);

export const GetUserAnalysesPaginatedDocument = `
    query GetUserAnalysesPaginated($type: AnalysisType!, $cursor: String, $limit: Int) {
  getUserAnalysesPaginated(type: $type, cursor: $cursor, limit: $limit) {
    analyses {
      ...AnalysisBase
    }
    nextCursor
    hasNextPage
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useGetUserAnalysesPaginatedQuery = <
      TData = GetUserAnalysesPaginatedQuery,
      TError = unknown
    >(
      variables: GetUserAnalysesPaginatedQueryVariables,
      options?: Omit<UseQueryOptions<GetUserAnalysesPaginatedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserAnalysesPaginatedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserAnalysesPaginatedQuery, TError, TData>(
      {
    queryKey: ['GetUserAnalysesPaginated', variables],
    queryFn: graphqlClient<GetUserAnalysesPaginatedQuery, GetUserAnalysesPaginatedQueryVariables>(GetUserAnalysesPaginatedDocument, variables),
    ...options
  }
    )};

useGetUserAnalysesPaginatedQuery.getKey = (variables: GetUserAnalysesPaginatedQueryVariables) => ['GetUserAnalysesPaginated', variables];

export const useInfiniteGetUserAnalysesPaginatedQuery = <
      TData = InfiniteData<GetUserAnalysesPaginatedQuery>,
      TError = unknown
    >(
      variables: GetUserAnalysesPaginatedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserAnalysesPaginatedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserAnalysesPaginatedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserAnalysesPaginatedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUserAnalysesPaginated.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetUserAnalysesPaginatedQuery, GetUserAnalysesPaginatedQueryVariables>(GetUserAnalysesPaginatedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserAnalysesPaginatedQuery.getKey = (variables: GetUserAnalysesPaginatedQueryVariables) => ['GetUserAnalysesPaginated.infinite', variables];


useGetUserAnalysesPaginatedQuery.fetcher = (variables: GetUserAnalysesPaginatedQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetUserAnalysesPaginatedQuery, GetUserAnalysesPaginatedQueryVariables>(GetUserAnalysesPaginatedDocument, variables, options);

export const GetPublicAnalysisCategoriesDocument = `
    query GetPublicAnalysisCategories {
  getPublicAnalysisCategories {
    id
    name
    analyses {
      ...AnalysisBase
    }
  }
}
    ${AnalysisBaseFragmentDoc}`;

export const useGetPublicAnalysisCategoriesQuery = <
      TData = GetPublicAnalysisCategoriesQuery,
      TError = unknown
    >(
      variables?: GetPublicAnalysisCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<GetPublicAnalysisCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPublicAnalysisCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPublicAnalysisCategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPublicAnalysisCategories'] : ['GetPublicAnalysisCategories', variables],
    queryFn: graphqlClient<GetPublicAnalysisCategoriesQuery, GetPublicAnalysisCategoriesQueryVariables>(GetPublicAnalysisCategoriesDocument, variables),
    ...options
  }
    )};

useGetPublicAnalysisCategoriesQuery.getKey = (variables?: GetPublicAnalysisCategoriesQueryVariables) => variables === undefined ? ['GetPublicAnalysisCategories'] : ['GetPublicAnalysisCategories', variables];

export const useInfiniteGetPublicAnalysisCategoriesQuery = <
      TData = InfiniteData<GetPublicAnalysisCategoriesQuery>,
      TError = unknown
    >(
      variables: GetPublicAnalysisCategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetPublicAnalysisCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetPublicAnalysisCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetPublicAnalysisCategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetPublicAnalysisCategories.infinite'] : ['GetPublicAnalysisCategories.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetPublicAnalysisCategoriesQuery, GetPublicAnalysisCategoriesQueryVariables>(GetPublicAnalysisCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetPublicAnalysisCategoriesQuery.getKey = (variables?: GetPublicAnalysisCategoriesQueryVariables) => variables === undefined ? ['GetPublicAnalysisCategories.infinite'] : ['GetPublicAnalysisCategories.infinite', variables];


useGetPublicAnalysisCategoriesQuery.fetcher = (variables?: GetPublicAnalysisCategoriesQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetPublicAnalysisCategoriesQuery, GetPublicAnalysisCategoriesQueryVariables>(GetPublicAnalysisCategoriesDocument, variables, options);

export const GetAnalysisBrandDistributionDocument = `
    query GetAnalysisBrandDistribution($analysisId: ID!, $categoryPath: String) {
  getAnalysisBrandDistribution(
    analysisId: $analysisId
    categoryPath: $categoryPath
  ) {
    brand
    sellsCount
    totalSellsPrice
    avgSellsPrice
  }
}
    `;

export const useGetAnalysisBrandDistributionQuery = <
      TData = GetAnalysisBrandDistributionQuery,
      TError = unknown
    >(
      variables: GetAnalysisBrandDistributionQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisBrandDistributionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisBrandDistributionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisBrandDistributionQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisBrandDistribution', variables],
    queryFn: graphqlClient<GetAnalysisBrandDistributionQuery, GetAnalysisBrandDistributionQueryVariables>(GetAnalysisBrandDistributionDocument, variables),
    ...options
  }
    )};

useGetAnalysisBrandDistributionQuery.getKey = (variables: GetAnalysisBrandDistributionQueryVariables) => ['GetAnalysisBrandDistribution', variables];

export const useInfiniteGetAnalysisBrandDistributionQuery = <
      TData = InfiniteData<GetAnalysisBrandDistributionQuery>,
      TError = unknown
    >(
      variables: GetAnalysisBrandDistributionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisBrandDistributionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisBrandDistributionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisBrandDistributionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisBrandDistribution.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisBrandDistributionQuery, GetAnalysisBrandDistributionQueryVariables>(GetAnalysisBrandDistributionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisBrandDistributionQuery.getKey = (variables: GetAnalysisBrandDistributionQueryVariables) => ['GetAnalysisBrandDistribution.infinite', variables];


useGetAnalysisBrandDistributionQuery.fetcher = (variables: GetAnalysisBrandDistributionQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisBrandDistributionQuery, GetAnalysisBrandDistributionQueryVariables>(GetAnalysisBrandDistributionDocument, variables, options);

export const GetAnalysisCategoriesLevelsDistributionDocument = `
    query GetAnalysisCategoriesLevelsDistribution($analysisId: ID!) {
  getAnalysisCategoriesLevelsDistribution(analysisId: $analysisId) {
    level
    categories {
      categoryName
      fullPath
      level
      sellsCount
      totalSellsPrice
      avgSellsPrice
    }
  }
}
    `;

export const useGetAnalysisCategoriesLevelsDistributionQuery = <
      TData = GetAnalysisCategoriesLevelsDistributionQuery,
      TError = unknown
    >(
      variables: GetAnalysisCategoriesLevelsDistributionQueryVariables,
      options?: Omit<UseQueryOptions<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>(
      {
    queryKey: ['GetAnalysisCategoriesLevelsDistribution', variables],
    queryFn: graphqlClient<GetAnalysisCategoriesLevelsDistributionQuery, GetAnalysisCategoriesLevelsDistributionQueryVariables>(GetAnalysisCategoriesLevelsDistributionDocument, variables),
    ...options
  }
    )};

useGetAnalysisCategoriesLevelsDistributionQuery.getKey = (variables: GetAnalysisCategoriesLevelsDistributionQueryVariables) => ['GetAnalysisCategoriesLevelsDistribution', variables];

export const useInfiniteGetAnalysisCategoriesLevelsDistributionQuery = <
      TData = InfiniteData<GetAnalysisCategoriesLevelsDistributionQuery>,
      TError = unknown
    >(
      variables: GetAnalysisCategoriesLevelsDistributionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAnalysisCategoriesLevelsDistributionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAnalysisCategoriesLevelsDistribution.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAnalysisCategoriesLevelsDistributionQuery, GetAnalysisCategoriesLevelsDistributionQueryVariables>(GetAnalysisCategoriesLevelsDistributionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAnalysisCategoriesLevelsDistributionQuery.getKey = (variables: GetAnalysisCategoriesLevelsDistributionQueryVariables) => ['GetAnalysisCategoriesLevelsDistribution.infinite', variables];


useGetAnalysisCategoriesLevelsDistributionQuery.fetcher = (variables: GetAnalysisCategoriesLevelsDistributionQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAnalysisCategoriesLevelsDistributionQuery, GetAnalysisCategoriesLevelsDistributionQueryVariables>(GetAnalysisCategoriesLevelsDistributionDocument, variables, options);

export const GetProductByIdDocument = `
    query GetProductById($id: ID!) {
  getProductById(id: $id) {
    ...ProductBase
  }
}
    ${ProductBaseFragmentDoc}`;

export const useGetProductByIdQuery = <
      TData = GetProductByIdQuery,
      TError = unknown
    >(
      variables: GetProductByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProductByIdQuery, TError, TData>(
      {
    queryKey: ['GetProductById', variables],
    queryFn: graphqlClient<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, variables),
    ...options
  }
    )};

useGetProductByIdQuery.getKey = (variables: GetProductByIdQueryVariables) => ['GetProductById', variables];

export const useInfiniteGetProductByIdQuery = <
      TData = InfiniteData<GetProductByIdQuery>,
      TError = unknown
    >(
      variables: GetProductByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetProductByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProductById.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProductByIdQuery.getKey = (variables: GetProductByIdQueryVariables) => ['GetProductById.infinite', variables];


useGetProductByIdQuery.fetcher = (variables: GetProductByIdQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, variables, options);

export const GetAvailableBrandsDocument = `
    query GetAvailableBrands($analysisId: ID!, $status: ProductStatus) {
  getAvailableBrands(analysisId: $analysisId, status: $status) {
    brand
    count
  }
}
    `;

export const useGetAvailableBrandsQuery = <
      TData = GetAvailableBrandsQuery,
      TError = unknown
    >(
      variables: GetAvailableBrandsQueryVariables,
      options?: Omit<UseQueryOptions<GetAvailableBrandsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAvailableBrandsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAvailableBrandsQuery, TError, TData>(
      {
    queryKey: ['GetAvailableBrands', variables],
    queryFn: graphqlClient<GetAvailableBrandsQuery, GetAvailableBrandsQueryVariables>(GetAvailableBrandsDocument, variables),
    ...options
  }
    )};

useGetAvailableBrandsQuery.getKey = (variables: GetAvailableBrandsQueryVariables) => ['GetAvailableBrands', variables];

export const useInfiniteGetAvailableBrandsQuery = <
      TData = InfiniteData<GetAvailableBrandsQuery>,
      TError = unknown
    >(
      variables: GetAvailableBrandsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAvailableBrandsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAvailableBrandsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAvailableBrandsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAvailableBrands.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAvailableBrandsQuery, GetAvailableBrandsQueryVariables>(GetAvailableBrandsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAvailableBrandsQuery.getKey = (variables: GetAvailableBrandsQueryVariables) => ['GetAvailableBrands.infinite', variables];


useGetAvailableBrandsQuery.fetcher = (variables: GetAvailableBrandsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAvailableBrandsQuery, GetAvailableBrandsQueryVariables>(GetAvailableBrandsDocument, variables, options);

export const GetAvailableItemConditionsDocument = `
    query GetAvailableItemConditions($analysisId: ID!, $status: ProductStatus) {
  getAvailableItemConditions(analysisId: $analysisId, status: $status) {
    itemCondition
    count
  }
}
    `;

export const useGetAvailableItemConditionsQuery = <
      TData = GetAvailableItemConditionsQuery,
      TError = unknown
    >(
      variables: GetAvailableItemConditionsQueryVariables,
      options?: Omit<UseQueryOptions<GetAvailableItemConditionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAvailableItemConditionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAvailableItemConditionsQuery, TError, TData>(
      {
    queryKey: ['GetAvailableItemConditions', variables],
    queryFn: graphqlClient<GetAvailableItemConditionsQuery, GetAvailableItemConditionsQueryVariables>(GetAvailableItemConditionsDocument, variables),
    ...options
  }
    )};

useGetAvailableItemConditionsQuery.getKey = (variables: GetAvailableItemConditionsQueryVariables) => ['GetAvailableItemConditions', variables];

export const useInfiniteGetAvailableItemConditionsQuery = <
      TData = InfiniteData<GetAvailableItemConditionsQuery>,
      TError = unknown
    >(
      variables: GetAvailableItemConditionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAvailableItemConditionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAvailableItemConditionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAvailableItemConditionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAvailableItemConditions.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAvailableItemConditionsQuery, GetAvailableItemConditionsQueryVariables>(GetAvailableItemConditionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAvailableItemConditionsQuery.getKey = (variables: GetAvailableItemConditionsQueryVariables) => ['GetAvailableItemConditions.infinite', variables];


useGetAvailableItemConditionsQuery.fetcher = (variables: GetAvailableItemConditionsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAvailableItemConditionsQuery, GetAvailableItemConditionsQueryVariables>(GetAvailableItemConditionsDocument, variables, options);

export const GetProductsByStatusDocument = `
    query GetProductsByStatus($analysisId: ID!, $status: ProductStatus!) {
  getProductsByStatus(analysisId: $analysisId, status: $status) {
    ...ProductBase
  }
}
    ${ProductBaseFragmentDoc}`;

export const useGetProductsByStatusQuery = <
      TData = GetProductsByStatusQuery,
      TError = unknown
    >(
      variables: GetProductsByStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetProductsByStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProductsByStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProductsByStatusQuery, TError, TData>(
      {
    queryKey: ['GetProductsByStatus', variables],
    queryFn: graphqlClient<GetProductsByStatusQuery, GetProductsByStatusQueryVariables>(GetProductsByStatusDocument, variables),
    ...options
  }
    )};

useGetProductsByStatusQuery.getKey = (variables: GetProductsByStatusQueryVariables) => ['GetProductsByStatus', variables];

export const useInfiniteGetProductsByStatusQuery = <
      TData = InfiniteData<GetProductsByStatusQuery>,
      TError = unknown
    >(
      variables: GetProductsByStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProductsByStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProductsByStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetProductsByStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProductsByStatus.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetProductsByStatusQuery, GetProductsByStatusQueryVariables>(GetProductsByStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProductsByStatusQuery.getKey = (variables: GetProductsByStatusQueryVariables) => ['GetProductsByStatus.infinite', variables];


useGetProductsByStatusQuery.fetcher = (variables: GetProductsByStatusQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetProductsByStatusQuery, GetProductsByStatusQueryVariables>(GetProductsByStatusDocument, variables, options);

export const GetNicheSoldProductsDocument = `
    query GetNicheSoldProducts($analysisId: ID!, $brandOrFullPath: String!) {
  getNicheSoldProducts(analysisId: $analysisId, brandOrFullPath: $brandOrFullPath) {
    ...ProductBase
  }
}
    ${ProductBaseFragmentDoc}`;

export const useGetNicheSoldProductsQuery = <
      TData = GetNicheSoldProductsQuery,
      TError = unknown
    >(
      variables: GetNicheSoldProductsQueryVariables,
      options?: Omit<UseQueryOptions<GetNicheSoldProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNicheSoldProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetNicheSoldProductsQuery, TError, TData>(
      {
    queryKey: ['GetNicheSoldProducts', variables],
    queryFn: graphqlClient<GetNicheSoldProductsQuery, GetNicheSoldProductsQueryVariables>(GetNicheSoldProductsDocument, variables),
    ...options
  }
    )};

useGetNicheSoldProductsQuery.getKey = (variables: GetNicheSoldProductsQueryVariables) => ['GetNicheSoldProducts', variables];

export const useInfiniteGetNicheSoldProductsQuery = <
      TData = InfiniteData<GetNicheSoldProductsQuery>,
      TError = unknown
    >(
      variables: GetNicheSoldProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetNicheSoldProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetNicheSoldProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetNicheSoldProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetNicheSoldProducts.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetNicheSoldProductsQuery, GetNicheSoldProductsQueryVariables>(GetNicheSoldProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetNicheSoldProductsQuery.getKey = (variables: GetNicheSoldProductsQueryVariables) => ['GetNicheSoldProducts.infinite', variables];


useGetNicheSoldProductsQuery.fetcher = (variables: GetNicheSoldProductsQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetNicheSoldProductsQuery, GetNicheSoldProductsQueryVariables>(GetNicheSoldProductsDocument, variables, options);

export const GetAvailableSubscriptionPlansDocument = `
    query GetAvailableSubscriptionPlans {
  getAvailableSubscriptionPlans {
    id
    name
    isPublic
    priceMonthly
    priceYearly
    catalogAnalysisQuotas
    profileAnalysisQuotas
    trialPeriodDays
  }
}
    `;

export const useGetAvailableSubscriptionPlans = <
      TData = GetAvailableSubscriptionPlansQuery,
      TError = unknown
    >(
      variables?: GetAvailableSubscriptionPlansQueryVariables,
      options?: Omit<UseQueryOptions<GetAvailableSubscriptionPlansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAvailableSubscriptionPlansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAvailableSubscriptionPlansQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAvailableSubscriptionPlans'] : ['GetAvailableSubscriptionPlans', variables],
    queryFn: graphqlClient<GetAvailableSubscriptionPlansQuery, GetAvailableSubscriptionPlansQueryVariables>(GetAvailableSubscriptionPlansDocument, variables),
    ...options
  }
    )};

useGetAvailableSubscriptionPlans.getKey = (variables?: GetAvailableSubscriptionPlansQueryVariables) => variables === undefined ? ['GetAvailableSubscriptionPlans'] : ['GetAvailableSubscriptionPlans', variables];

export const useInfiniteGetAvailableSubscriptionPlans = <
      TData = InfiniteData<GetAvailableSubscriptionPlansQuery>,
      TError = unknown
    >(
      variables: GetAvailableSubscriptionPlansQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAvailableSubscriptionPlansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAvailableSubscriptionPlansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAvailableSubscriptionPlansQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetAvailableSubscriptionPlans.infinite'] : ['GetAvailableSubscriptionPlans.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetAvailableSubscriptionPlansQuery, GetAvailableSubscriptionPlansQueryVariables>(GetAvailableSubscriptionPlansDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAvailableSubscriptionPlans.getKey = (variables?: GetAvailableSubscriptionPlansQueryVariables) => variables === undefined ? ['GetAvailableSubscriptionPlans.infinite'] : ['GetAvailableSubscriptionPlans.infinite', variables];


useGetAvailableSubscriptionPlans.fetcher = (variables?: GetAvailableSubscriptionPlansQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetAvailableSubscriptionPlansQuery, GetAvailableSubscriptionPlansQueryVariables>(GetAvailableSubscriptionPlansDocument, variables, options);

export const GetCurrentUserSubscriptionDocument = `
    query GetCurrentUserSubscription {
  getCurrentUserSubscription {
    isActive
    plan {
      id
      name
      periodicity
      price
      nextRenewalAt
    }
    inactivatedAt
  }
}
    `;

export const useGetCurrentUserSubscription = <
      TData = GetCurrentUserSubscriptionQuery,
      TError = unknown
    >(
      variables?: GetCurrentUserSubscriptionQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentUserSubscriptionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentUserSubscriptionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentUserSubscriptionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetCurrentUserSubscription'] : ['GetCurrentUserSubscription', variables],
    queryFn: graphqlClient<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>(GetCurrentUserSubscriptionDocument, variables),
    ...options
  }
    )};

useGetCurrentUserSubscription.getKey = (variables?: GetCurrentUserSubscriptionQueryVariables) => variables === undefined ? ['GetCurrentUserSubscription'] : ['GetCurrentUserSubscription', variables];

export const useInfiniteGetCurrentUserSubscription = <
      TData = InfiniteData<GetCurrentUserSubscriptionQuery>,
      TError = unknown
    >(
      variables: GetCurrentUserSubscriptionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentUserSubscriptionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentUserSubscriptionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCurrentUserSubscriptionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetCurrentUserSubscription.infinite'] : ['GetCurrentUserSubscription.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>(GetCurrentUserSubscriptionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentUserSubscription.getKey = (variables?: GetCurrentUserSubscriptionQueryVariables) => variables === undefined ? ['GetCurrentUserSubscription.infinite'] : ['GetCurrentUserSubscription.infinite', variables];


useGetCurrentUserSubscription.fetcher = (variables?: GetCurrentUserSubscriptionQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetCurrentUserSubscriptionQuery, GetCurrentUserSubscriptionQueryVariables>(GetCurrentUserSubscriptionDocument, variables, options);

export const GetCurrentUserAnalysisQuotasDocument = `
    query GetCurrentUserAnalysisQuotas {
  getCurrentUserAnalysisQuotas {
    hasPartialPublicAnalysisAccess
    hasFullPublicAnalysisAccess
    catalogAnalysesUsed
    catalogAnalysesMax
    catalogAnalysesAvailable
    profileAnalysesUsed
    profileAnalysesMax
    profileAnalysesAvailable
    canCreateCatalogAnalysis
    canCreateProfileAnalysis
  }
}
    `;

export const useGetCurrentUserAnalysisQuotasQuery = <
      TData = GetCurrentUserAnalysisQuotasQuery,
      TError = unknown
    >(
      variables?: GetCurrentUserAnalysisQuotasQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentUserAnalysisQuotasQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentUserAnalysisQuotasQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentUserAnalysisQuotasQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetCurrentUserAnalysisQuotas'] : ['GetCurrentUserAnalysisQuotas', variables],
    queryFn: graphqlClient<GetCurrentUserAnalysisQuotasQuery, GetCurrentUserAnalysisQuotasQueryVariables>(GetCurrentUserAnalysisQuotasDocument, variables),
    ...options
  }
    )};

useGetCurrentUserAnalysisQuotasQuery.getKey = (variables?: GetCurrentUserAnalysisQuotasQueryVariables) => variables === undefined ? ['GetCurrentUserAnalysisQuotas'] : ['GetCurrentUserAnalysisQuotas', variables];

export const useInfiniteGetCurrentUserAnalysisQuotasQuery = <
      TData = InfiniteData<GetCurrentUserAnalysisQuotasQuery>,
      TError = unknown
    >(
      variables: GetCurrentUserAnalysisQuotasQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentUserAnalysisQuotasQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentUserAnalysisQuotasQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCurrentUserAnalysisQuotasQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetCurrentUserAnalysisQuotas.infinite'] : ['GetCurrentUserAnalysisQuotas.infinite', variables],
      queryFn: (metaData) => graphqlClient<GetCurrentUserAnalysisQuotasQuery, GetCurrentUserAnalysisQuotasQueryVariables>(GetCurrentUserAnalysisQuotasDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentUserAnalysisQuotasQuery.getKey = (variables?: GetCurrentUserAnalysisQuotasQueryVariables) => variables === undefined ? ['GetCurrentUserAnalysisQuotas.infinite'] : ['GetCurrentUserAnalysisQuotas.infinite', variables];


useGetCurrentUserAnalysisQuotasQuery.fetcher = (variables?: GetCurrentUserAnalysisQuotasQueryVariables, options?: RequestInit['headers']) => graphqlClient<GetCurrentUserAnalysisQuotasQuery, GetCurrentUserAnalysisQuotasQueryVariables>(GetCurrentUserAnalysisQuotasDocument, variables, options);
